module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_800x400-12bbfd3fc7c38250e45f971d95e822d6.jpg";